import React from "react";
import { Input } from "components/Input";
import { Body, Header } from "components/Table/style";
import { Table } from "../../style";

export function EssencialOils(props) {
  return (
    <Table>
      <Header>
        <tr>
          <th style={{ width: "185px" }}>
            <span></span>
          </th>
          <th>
            <span>Qual Produto?</span>
          </th>
          <th>
            <span>Qual Finalidade?</span>
          </th>
          <th>
            <span>Qual Dose?</span>
          </th>
        </tr>
      </Header>
      <Body>
        <tr>
          <td>Pré</td>
          <td>
            <Input
              type="inputOnly"
              params="additions.essencialOils.pre.product"
              item={props.megg}
              setItem={props.setMegg}
              placeholder="Digite o Produto"
            />
          </td>
          <td>
            <Input
              type="inputOnly"
              params="additions.essencialOils.pre.reason"
              item={props.megg}
              setItem={props.setMegg}
            />
          </td>
          <td>
            <Input
              type="inputOnly"
              params="additions.essencialOils.pre.dose"
              item={props.megg}
              setItem={props.setMegg}
            />
          </td>
        </tr>
        <tr>
          <td>Inicial</td>
          <td>
            <Input
              type="inputOnly"
              params="additions.essencialOils.initial.product"
              item={props.megg}
              setItem={props.setMegg}
              placeholder="Digite o Produto"
            />
          </td>
          <td>
            <Input
              type="inputOnly"
              params="additions.essencialOils.initial.reason"
              item={props.megg}
              setItem={props.setMegg}
            />
          </td>
          <td>
            <Input
              type="inputOnly"
              params="additions.essencialOils.initial.dose"
              item={props.megg}
              setItem={props.setMegg}
            />
          </td>
        </tr>
        <tr>
          <td>Crescimento</td>
          <td>
            <Input
              type="inputOnly"
              params="additions.essencialOils.growth.product"
              item={props.megg}
              setItem={props.setMegg}
              placeholder="Digite o Produto"
            />
          </td>
          <td>
            <Input
              type="inputOnly"
              params="additions.essencialOils.growth.reason"
              item={props.megg}
              setItem={props.setMegg}
            />
          </td>
          <td>
            <Input
              type="inputOnly"
              params="additions.essencialOils.growth.dose"
              item={props.megg}
              setItem={props.setMegg}
            />
          </td>
        </tr>
        <tr>
          <td>Desenvolvimento</td>
          <td>
            <Input
              type="inputOnly"
              params="additions.essencialOils.development.product"
              item={props.megg}
              setItem={props.setMegg}
              placeholder="Digite o Produto"
            />
          </td>
          <td>
            <Input
              type="inputOnly"
              params="additions.essencialOils.development.reason"
              item={props.megg}
              setItem={props.setMegg}
            />
          </td>
          <td>
            <Input
              type="inputOnly"
              params="additions.essencialOils.development.dose"
              item={props.megg}
              setItem={props.setMegg}
            />
          </td>
        </tr>
      </Body>
    </Table>
  );
}
